
import $ from "jquery"

const SIGNIN_SIGNUP_BOX = "state-sign-in"
const FORGOT_PASSWORD_BOX = "state-forgot-password"
const CELL_CLASS = ".cell-authentication-box"
const SIGNIN_EMAIL_INPUT = ".cell-section-auth--sign-in__email-input"
const FORGOT_PASSWORD_BOX_EMAIL_INPUT = ".cell-section-auth--forgot-password__email-input"

const $body = $("body")
// should combine with concepts/authentication/modal/switch_sign_up_sing_in ?

// TODO: This init should be call after modal appear to prevent event listener on body
const init = () => {
  $body.on("click", `${CELL_CLASS} .js-switch-sign-up-in`, (e) => {
    e.preventDefault()
    const $el = $(e.currentTarget)
    $el.closest(CELL_CLASS).toggleClass(SIGNIN_SIGNUP_BOX)
    $el.closest(CELL_CLASS).removeClass(FORGOT_PASSWORD_BOX)
  })

  $body.on("click", `${CELL_CLASS} .js-switch-forgot-password`, (e) => {
    e.preventDefault()
    const $el = $(e.currentTarget)
    $el.closest(CELL_CLASS).toggleClass(FORGOT_PASSWORD_BOX)
    const signin_email_input = $el.closest(CELL_CLASS).find(SIGNIN_EMAIL_INPUT).val()
    $el.closest(CELL_CLASS).find(FORGOT_PASSWORD_BOX_EMAIL_INPUT).val(signin_email_input)
  })
}

export default {init}
